"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createModule = createModule;

var _commonEnv = _interopRequireDefault(require("@ifly/common-env"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reducers = require("./reducers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Creates a redux module.
 *
 * @param {object} params
 * @param {string} params.name The name of the module. This name
 *    is also used as the key for whatever state slice this module manages
 * @param {object} params.initialState The initial state for the slice that
 *    this module manages
 * @param {object} params.actions The actions to be defined. Actions
 *   take the structure:
 *   {} = use the default reducer for this action
 *   {dispatch: true} = When connected your component gets an `actions`
 *      property with all dispatchable actions.
 *   {reducer: false} = some other reducer, unknown to this module,
 *      will process the action
 *   {reducer: <some function>} = this action will always be reduced
 *     using the specified function
 *   {args: ['foo', 'bar']} = this action will take a list
 *      of parameter names and map them them to an object:
 *      { foo: 1, bar: 9}
 *      If not defined, we expect the params to be an *      object.
 *  @param {object} params.selector If selectors are defined, these
 *      become available to any component that needs to consume
 *      a portion of the module's state. A `default` selector
 *      is always available for each module, which returns the
 *      entire state slice that the module manages.
 * @param {function} params.reducer Specifies the default reducer for this module
 */
function createModule(_ref) {
  var name = _ref.name,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? {} : _ref$actions,
      _ref$selector = _ref.selector,
      selector = _ref$selector === void 0 ? {} : _ref$selector,
      unknownConfigs = _objectWithoutProperties(_ref, ["name", "initialState", "actions", "selector"]);

  var constants = {};
  var customReducers = {};
  var defaultReducer = (0, _reducers.sliceReducer)(name);
  var dispatchable = {};

  var SHOW_WARNING = _commonEnv["default"].isDevelopment();

  if (SHOW_WARNING && Object.keys(unknownConfigs).length) {
    console.info("@ifly/redux-modules -- createModule: ".concat(name, " -- configuration warning -- Module contains unrecognized config: \"").concat(Object.keys(unknownConfigs).join('", "'), "\"")); // unexpected config params
  }

  Object.freeze(initialState); /// The default redux state selector is keyed by module name.

  selector["default"] = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    return state[name];
  }; /// Configure each action, its type constant, and custom reducer (if any).


  for (var slug in actions) {
    var params = _objectSpread({}, actions[slug]);

    if (SHOW_WARNING && Array.isArray(params.args) && params.args.includes('type')) {
      console.warn("@ifly/redux-modules -- createModule: ".concat(name, " -- configuration error -- In action \"").concat(slug, "\" the args array contains the reserved word \"type\". Actions use \"type\" (an auto-generated constant comprised of the module and action name) to identify themselves.  Choose a different argument name.")); // this will break the app
    }

    actions[slug] = generateAction(name, slug, params, customReducers);
    constants[slug] = actions[slug]().type;
    var dispatch = params.dispatch,
        reducer = params.reducer; // If the action's reducer is false the action is typically handled by 
    // a saga so it's most likely a component will dispatch the action. We
    // want developers to be explicit, so support the syntax but complain.

    var isMaybeDispatch = undefined === dispatch && false === reducer;

    if (SHOW_WARNING && isMaybeDispatch) {
      console.info("@ifly/redux-modules -- createModule: ".concat(name, " -- configuration warning -- In action \"").concat(slug, "\" the reducer is false, but dispatch is not true. Add dispatch:true so it is explicit this action is to be called by a React component.")); // discouraged syntax
    } // if the action's reducer is false, that typically means it's being handled by a 
    // saga. in this case, it's almost certain that we want to dispatch this action.


    if (params.dispatch || isMaybeDispatch) dispatchable[slug] = actions[slug];
  } /// When connected your component gets an `actions` property with all dispatchable actions.


  var bindModuleActions = function bindModuleActions(dispatch, props) {
    var actions = (0, _redux.bindActionCreators)(dispatchable, dispatch); // pass along existing actions so components can connect to multiple modules

    if (props.actions) actions = _objectSpread({}, props.actions, {}, actions);
    return {
      actions: actions
    };
  };

  return {
    name: name,
    /// The module name (and redux state key).
    actions: actions,
    /// Map of actions.
    selector: selector,
    /// Map of selectors configured for the module (including the default).
    constants: constants,
    /// Map of constants identifying each action.
    initialState: initialState,
    /// The starting state for the module.
    /// Connects your component to the module's state and (dispatchable) actions.
    connect: function connect(Component) {
      var mapStateToProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : selector["default"];
      var mapDispatchToProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : bindModuleActions;

      for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      return _reactRedux.connect.apply(void 0, [mapStateToProps, mapDispatchToProps].concat(args))(Component);
    },
    /// To be supplied to the redux call `combineReducers` to wire up the module. 
    reducer: function reducer() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      return customReducers[action.type] ? customReducers[action.type](state, action) : defaultReducer(state, action);
    }
  };
}
/**
 * Generate the action `type` string based on component strings
 * @param {string} namespace the root namespace
 * @param {string} name the name that the action type will be based on
 * @param {object} params parameters that define the action type
 */


function generateActionType(namespace, name) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var bypassReducer = params.reducer === false;
  var typePrefix = bypassReducer ? "@@" : "";
  var renamed = name.replace(/\B([A-Z])/g, "_$1").toUpperCase();
  return "".concat(typePrefix).concat(namespace, "/").concat(renamed);
}
/**
 * Generate an action based on component strings
 * @param {string} namespace the root namespace
 * @param {string} name the name that the action type will be based on
 * @param {object} params parameters that define the action type
 * @param {string} params.reducer if defined, the action type will be defined such that only that reducer can access it
 * @param {string} params.args if defined, the action type will be defined such that only that reducer can access it
 * @param {object} customReducers the custom reducers, so that a new one can be added for this action, if needed
 */


function generateAction(key, name) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var customReducers = arguments.length > 3 ? arguments[3] : undefined;
  var type = generateActionType(key, name, params);

  if (params.reducer) {
    customReducers[type] = params.reducer;
  }

  if (params.args) {
    // this type of action takes regular params, instead of
    // a params object
    return function () {
      var payload = {};

      for (var i = 0, _i = arguments.length; i < _i; i++) {
        payload[params.args[i]] = i < 0 || arguments.length <= i ? undefined : arguments[i];
      }

      return _objectSpread({
        type: type
      }, payload);
    };
  } else {
    return function (args) {
      return _objectSpread({
        type: type
      }, args);
    };
  }
}